<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
// import echarts from "echarts";
var echarts = require("echarts");
import { on, off } from "@/libs/tools";
export default {
  name: "ChartBar",
  props: {
    value: Object,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      this.$nextTick(() => {
        // console.log(val)
        let xAxisData = Object.keys(val);
        let data = Object.values(val);
        let data1 = [];
        let data2 = [];
        data.forEach((item) => {
          data1.push(item.checked);
          data2.push(item.nocheck);
        });
        let option = {
          color: ["#f7c72c", "#87cd62"],
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          legend: {
            bottom: "3%",
            left: "center",
          },
          // toolbox: {
          //   show: true,
          //   orient: "vertical",
          //   left: "right",
          //   top: "center",
          //   feature: {
          //     mark: { show: true },
          //     dataView: { show: true, readOnly: false },
          //     magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
          //     restore: { show: true },
          //     saveAsImage: { show: true },
          //   },
          // },
          xAxis: [
            {
              type: "category",
              axisTick: { show: false },
              axisLabel: {
                rotate: 25,
                fontSize: "10px",
              },
              data: xAxisData,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: [
            {
              name: "已预报到",
              type: "bar",
              barGap: "40%",
              barWidth: "16%",
              label: {
                show: true,
                position: "top",
                formatter: "{c} ",
                fontSize: 16,
                color: "#000",
              },
              // data: [320, 332, 301, 334, 390],
              data: data1,
            },
            {
              name: "未预报到",
              type: "bar",
              barWidth: "16%",
              label: {
                show: true,
                position: "top",
                formatter: "{c} ",
                fontSize: 16,
                color: "#000",
              },
              // data: [220, 182, 191, 234, 290],
              data: data2,
            },
          ],
        };

        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },
  mounted() {
    this.loadEcharts(this.value);
  },
  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>
